import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import get, { post } from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { LoadingMgs } from "components/Common/toastify.jsx";
import { SuccessMessage } from "components/Common/toastify.jsx";
import { setCart } from "redux/ducks/cartSlice.js";
import { setDashboard } from "redux/ducks/CSPDashboardSlice.js";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const OrderSummaryCMP = () => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const classes = useStyles();
	const customerDetails = useSelector((state) => state.customer);
	const dispatch = useDispatch();
	const cartDetails = useSelector((state) => state.cart);
	const navigate = useNavigate();

	const validationSchema = Yup.object().shape({
		products_confirm: Yup.array()
			.of(
				Yup.object().shape({
					id: Yup.string().required("Product ID is required"),
					confirmed: Yup.boolean().oneOf([true], "This product must be confirmed"),
				})
			)
			.required("Please confirm all products"),
		i_agree_nce: Yup.boolean().oneOf(
			[true],
			"You must agree to the NCE affirmation of contract terms"
		),
		i_agree_partner: Yup.boolean().oneOf(
			[true],
			"You must agree to the Partner Attestation"
		),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		const formFieldData = {
			csp_order_id: cartDetails?.csp_order_id,
			order_comment: cartDetails?.special_instruction ?? "",
		};
		setLoading(true);
		LoadingMgs("Add Subscription", "processing...");
		try {
			await post(`/api/${cartDetails?.gotforcheckout}`, formFieldData, true)
				.then((res) => {
					const response = res.data;
					if (response.success) {
						SuccessMessage(
							"Add Subscription",
							response.records.message || "Subscription added successfully"
						);
						reset();

						dispatch(
							setDashboard({
								OrderSummary: false,
								ConfirmOrder: false,
								Heading: "Microsoft 365",
								TeamT5Form: false,
								KinetixForm: false,
								CustomerSubscriptionDetails: true,
								AddCustomerSubscription: false,
								selectedDialogData: null,
							})
						);

						// navigate("/csp-dashboard");
						window.location.href = "/csp-dashboard";
					} else {
						if (response?.records?.redirectto !== "") {
							window.location.href = response?.records?.redirectto;
						}
						ErrorMessage("Add Subscription", res.data.message);
					}

					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Add Subscription", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Add Subscription", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getCartsDetails();
		return function cleanup() {};
	}, []);

	useEffect(() => {
		console.log(cartDetails, "cartDetails");
	}, [cartDetails]);

	const extractData = (cartItems) => {
		const productList = cartItems?.cartitems?.map((item) => {
			return [
				prepareTitle(item),
				item?.quantity,
				item?.commitment_period,
				item?.billing_frequency,
				confirmCheckBox(item),
			];
		});
		return productList;
	};

	const confirmCheckBox = (item) => {
		return (
			<div className="flex">
				<input
					type="checkbox"
					{...register(`products_confirm.${item?.id}.confirmed`)}
				/>
				{item.name}
				<input
					type="hidden"
					value={item.id}
					{...register(`products_confirm.${item?.id}.id`)}
				/>
				&nbsp; &nbsp;
				{errors.products_confirm?.[item?.id]?.confirmed && (
					<div style={{ color: "red", fontSize: "12px" }}>
						{errors.products_confirm[item?.id].confirmed.message}
					</div>
				)}
			</div>
		);
	};

	const prepareTitle = (product) => {
		return (
			<>
				<div className={classesCSStyles?.labelAc}>
					<h4>{product.Description}</h4>
				</div>
				<div>
					STOCK CODE: <span>{product.Stockcode}</span>
				</div>
			</>
		);
	};

	const getCartsDetails = async () => {
		setLoading(true);
		try {
			await get(`/api/cart/list/${customerDetails?.tenantId}`, true)
				.then((res) => {
					if (res.data.success) {
						dispatch(setCart(res.data.records));
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("Products", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Products", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Products", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const moveToCompleteOrder = () => {
		dispatch(
			setDashboard({
				OrderSummary: true,
				ConfirmOrder: false,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
	};

	const goBack = () => {
		dispatch(
			setDashboard({
				OrderSummary: false,
				ConfirmOrder: true,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
			})
		);
	};

	return (
		<div className={classesCSStyles.mx5}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader color="info" className="">
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>Order Summary</h4>
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody
					className={classNames(
						classesCSStyles.accountSection,
						classesCSStyles.my10
					)}>
					<form onSubmit={handleSubmit(onSubmit)} id="myForm">
						<GridContainer className={classNames(classesCSStyles.marginAuto)}>
							<GridItem
								xs={12}
								sm={12}
								md={12}
								className={classNames(loading ? classesCSStyles.loading : "")}>
								<Table
									striped
									tableHead={[
										"DESCRIPTION",
										"QTY",
										"COMMITMENT PERIOD",
										"BILLING FREQUENCY",
										"CONFIRM",
									]}
									tableData={extractData(cartDetails)}
									customCellClasses={[
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
										classes.textLeft,
									]}
									customClassesForCells={[0, 1, 2, 3, 4, 5]}
									customHeadCellClasses={[
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
									]}
									customHeadClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
								/>
								{loading && (
									<Loading
										width={30}
										height={30}
										className={classesCSStyles.absoluteLoading}
									/>
								)}
								{!loading &&
									(cartDetails.length === 0 || cartDetails?.length === 0) && (
										<div className={classNames(classesCSStyles?.my10)}>
											No items in cart!
										</div>
									)}
							</GridItem>
							<GridItem xs={12} sm={12} md={12} lg={12}>
								<hr />
								<div className={classesCSStyles?.my10}>
									<h2
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.bigLabel
										)}>
										NCE AFFIRMATION OF CONTRACT TERMS
									</h2>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I. THE RESELLER UNDERSTAND THAT THE NCE LICENSES I AM REOUESTING FOR
										PURCHASE ARE LOCK-IN CONTRACTS FOR THE PERIOD OF THE COMMITMENT TERM
										AS PER DESCRIPTION.{" "}
									</div>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I ACKNOWLEDGE THAT THESE LICENSES ARE UNCONDITIONALLY NON-REFUNDABLE
										AFTER 7 DAYS FROM THE SUBSCRIPTION PURCHASE OR RENEWAL, AND,
									</div>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I, THE RESELLER AM LIABLE FOR THESE LICENSES FOR THE FULL TERM OF THE
										COMMITMENT PERIOD.
									</div>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I CONFIRM THAT I AM AUTHORIZED TO ACT ON BEHALF OF THE RESELLER.
									</div>
									<label
										htmlFor="i_agree_nce"
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										<input
											id="i_agree_nce"
											type="checkbox"
											{...register(`i_agree_nce`)}
										/>{" "}
										&nbsp; <span>I Agree</span>
									</label>
									{errors.i_agree_nce && (
										<div style={{ color: "red", fontSize: "12px" }}>
											{errors.i_agree_nce.message}
										</div>
									)}
									<div className={classesCSStyles?.py2}>
										<hr />
									</div>
									<h2
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.bigLabel
										)}>
										Partner Attestation
									</h2>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I confirm that my organization is acting as an Indirect Partner when
										choosing a Reseller and as a Direct Partner in the absence of
										selecting a reseller.
									</div>
									<div
										className={classNames(
											classesCSStyles?.py2,
											classesCSStyles?.subLabel
										)}>
										I confirm that I am not reselling products purchased within this order
										to other partners that are affiliated with my parent organization.{" "}
									</div>
									<label
										htmlFor="i_agree_partner"
										className={classNames(classesCSStyles?.subLabel)}>
										<input
											id="i_agree_partner"
											type="checkbox"
											{...register(`i_agree_partner`)}
										/>{" "}
										&nbsp; I Agree
									</label>
									{errors.i_agree_partner && (
										<div style={{ color: "red", fontSize: "12px" }}>
											{errors.i_agree_partner.message}
										</div>
									)}
								</div>
							</GridItem>
							<GridItem
								xs={12}
								sm={12}
								md={12}
								lg={12}
								className={classesCSStyles?.moveRight}>
								{/* <Button
									type="submit"
									disabled={loading}
									color="info"
									size="sm"
									onClick={() => moveToCompleteOrder()}>
									Complete Order
								</Button> */}
								<button
									disabled={loading}
									className={classNames(classesCSStyles?.buttonPrimary)}
									onClick={() => moveToCompleteOrder()}>
									Complete Order
								</button>
								&nbsp;{" "}
								<Button color="primary" size="sm" onClick={() => goBack()}>
									Go Back
								</Button>
							</GridItem>
						</GridContainer>
					</form>
				</CardBody>
			</Card>
		</div>
	);
};

export default OrderSummaryCMP;
